namespace TabAurous.Sales {
    export namespace SalesFiltersService {
        export const baseUrl = 'Sales/SalesFilters';

        export declare function WeeklySales(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function MonthlySales(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function QuarterlySales(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            WeeklySales = "Sales/SalesFilters/WeeklySales",
            MonthlySales = "Sales/SalesFilters/MonthlySales",
            QuarterlySales = "Sales/SalesFilters/QuarterlySales"
        }

        [
            'WeeklySales', 
            'MonthlySales', 
            'QuarterlySales'
        ].forEach(x => {
            (<any>SalesFiltersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
